import PageSkeleton from '@/layout/Skeleton';
import { FunctionComponent } from 'react';

interface iDashboardProps {}

const Dashboard: FunctionComponent<iDashboardProps> = () => {
  return <PageSkeleton steps={[{ label: 'Dashboard', href: '/' }]}></PageSkeleton>;
};

export default Dashboard;
